"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopProductStockSkuToJSON = exports.ShopProductStockSkuFromJSONTyped = exports.ShopProductStockSkuFromJSON = exports.instanceOfShopProductStockSku = void 0;
var runtime_1 = require("../runtime");
var CommDate_1 = require("./CommDate");
var PriceInformation_1 = require("./PriceInformation");
var PriceValue_1 = require("./PriceValue");
var ProductStock_1 = require("./ProductStock");
/**
 * Check if a given object implements the ShopProductStockSku interface.
 */
function instanceOfShopProductStockSku(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfShopProductStockSku = instanceOfShopProductStockSku;
function ShopProductStockSkuFromJSON(json) {
    return ShopProductStockSkuFromJSONTyped(json, false);
}
exports.ShopProductStockSkuFromJSON = ShopProductStockSkuFromJSON;
function ShopProductStockSkuFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'sku': !(0, runtime_1.exists)(json, 'sku') ? undefined : json['sku'],
        'sort': !(0, runtime_1.exists)(json, 'sort') ? undefined : json['sort'],
        'ean': !(0, runtime_1.exists)(json, 'ean') ? undefined : json['ean'],
        'inBox': !(0, runtime_1.exists)(json, 'inBox') ? undefined : json['inBox'],
        'availableDate': !(0, runtime_1.exists)(json, 'availableDate') ? undefined : (0, CommDate_1.CommDateFromJSON)(json['availableDate']),
        'stock': !(0, runtime_1.exists)(json, 'stock') ? undefined : (json['stock'] === null ? null : json['stock'].map(ProductStock_1.ProductStockFromJSON)),
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : (0, PriceValue_1.PriceValueFromJSON)(json['price']),
        'fallbackPrice': !(0, runtime_1.exists)(json, 'fallbackPrice') ? undefined : (0, PriceInformation_1.PriceInformationFromJSON)(json['fallbackPrice']),
        'parsedSku': !(0, runtime_1.exists)(json, 'parsedSku') ? undefined : json['parsedSku'],
    };
}
exports.ShopProductStockSkuFromJSONTyped = ShopProductStockSkuFromJSONTyped;
function ShopProductStockSkuToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'sku': value.sku,
        'ean': value.ean,
        'inBox': value.inBox,
        'availableDate': (0, CommDate_1.CommDateToJSON)(value.availableDate),
        'stock': value.stock === undefined ? undefined : (value.stock === null ? null : value.stock.map(ProductStock_1.ProductStockToJSON)),
        'price': (0, PriceValue_1.PriceValueToJSON)(value.price),
        'fallbackPrice': (0, PriceInformation_1.PriceInformationToJSON)(value.fallbackPrice),
        'parsedSku': value.parsedSku,
    };
}
exports.ShopProductStockSkuToJSON = ShopProductStockSkuToJSON;
